import { Circle, MapContainer, Marker, Polyline, TileLayer, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import useGeolocation from "../useGeolocation";
import { useEffect, useState } from "react";
import LoadingCircle from "../../utility/LoadingCircle";
import personWalkingIcon from "../../../assets/person-walking.svg";

let DefaultIcon = L.icon({
	iconUrl: icon,
	shadowUrl: iconShadow,
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
});

let UserIcon = L.icon({
	iconUrl: personWalkingIcon,
	shadowUrl: iconShadow,
	iconSize: [41, 41],
	iconAnchor: [20.5, 41],
	popupAnchor: [1, -34],
});

const METER_CONVERSION_TO_MILES = 1609.34;

const FitBounds = ({ positions }) => {
	const map = useMap();

	useEffect(() => {
		if (positions.length >= 2) {
			const bounds = L.latLngBounds(positions);
			map.fitBounds(bounds, { padding: [50, 50] });
		}
	}, [positions, map]);

	return null;
};

const ProjectGeofencing = ({ projectLocation, setShowGeofencingModal, actionText, actionFunction }) => {
	const [userLat, setUserLat] = useState(null);
	const [userLng, setUserLng] = useState(null);
	const [distanceFromSite, setDistanceFromSite] = useState(null);

	function haversineDistance(lat1, lon1, lat2, lon2) {
		const toRad = (val) => (val * Math.PI) / 180;
		const R = 3958.8; // Earth's radius in miles

		const dLat = toRad(lat2 - lat1);
		const dLon = toRad(lon2 - lon1);

		const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

		return R * c;
	}

	useEffect(() => {
		if (userLat && userLng && projectLocation) {
			const distance = haversineDistance(userLat, userLng, projectLocation.lat, projectLocation.lng);
			setDistanceFromSite(distance);
		}
	}, [userLat, userLng, projectLocation]);

	const getLocation = useGeolocation();
	useEffect(() => {
		const intervalId = setInterval(() => {
			getLocation().then((data) => {
				if (data?.lat) {
					setUserLat(data.lat);
				}
				if (data?.lng) {
					setUserLng(data.lng);
				}
			});
		}, 5000);

		return () => clearInterval(intervalId);
	}, [getLocation]);

	return !userLat || !userLng ? (
		<div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 z-[199] flex flex-col justify-center items-center p-3">
			<div className="bg-white flex flex-col justify-center items-center rounded-lg shadow-lg text-center p-4">
				<LoadingCircle />
				<p>This project has geofencing.</p>
				<p>If you're on PC, this may take longer to load as your laptop may not have good GPS support.</p>
			</div>
		</div>
	) : (
		<div className="fixed top-0 left-0 w-full h-screen z-[199] bg-white flex flex-col">
			<div className="p-4 text-center">
				{distanceFromSite && distanceFromSite > 5 ? (
					<p className="text-xl font-bold">
						This site has Geofencing.
						<br />
						Please get within 5 miles of the job site.
					</p>
				) : (
					<p className="text-xl font-bold">
						This site has Geofencing.
						<br />
						You are within 5 miles of the job.
					</p>
				)}
				<p className="text-sm">{`(If you think the job's latitude or longitude is incorrect, please contact IT.)`}</p>
				<div className="flex flex-col gap-1 mt-2">
					{distanceFromSite > 5 ? (
						<button className="bg-gray-500 hover:bg-gray-600 p-2 text-white rounded-lg" onClick={() => alert("Please get closer to the site.")}>
							{actionText}
						</button>
					) : (
						<button className="bg-blue-500 hover:bg-blue-600 p-2 text-white rounded-lg" onClick={actionFunction}>
							{actionText}
						</button>
					)}
					<button className="bg-gray-500 hover:bg-gray-600 p-2 text-white rounded-lg" onClick={() => setShowGeofencingModal(false)}>
						Close
					</button>
				</div>
			</div>

			<div className="flex-1">
				<MapContainer center={[userLat, userLng]} zoom={13} scrollWheelZoom={false} className="h-full w-full">
					<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
					<Polyline
						positions={[
							[userLat, userLng],
							[projectLocation.lat, projectLocation.lng],
						]}
					/>

					<FitBounds
						positions={[
							[userLat, userLng],
							[projectLocation.lat, projectLocation.lng],
						]}
					/>
					<Marker position={[userLat, userLng]} icon={UserIcon}>
						{distanceFromSite && distanceFromSite > 5 ? (
							<Tooltip direction="bottom" permanent>
								<>{`You're ~${distanceFromSite.toFixed(2)} miles away from the site.`}</>
							</Tooltip>
						) : (
							<Tooltip direction="bottom" permanent>
								YOU
							</Tooltip>
						)}
					</Marker>
					<Circle
						center={[projectLocation.lat, projectLocation.lng]}
						radius={METER_CONVERSION_TO_MILES * 5}
						pathOptions={{ color: "blue", fillColor: "blue", fillOpacity: 0.1 }}
					/>
					<Marker position={[projectLocation.lat, projectLocation.lng]} icon={DefaultIcon}>
						{/* <Tooltip permanent direction="bottom">
                    Destination
                </Tooltip> */}
					</Marker>
				</MapContainer>
			</div>
		</div>
	);
};

export default ProjectGeofencing;
